import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ContextService } from '@app/core/service/context.service';
import { Ad } from '@app/core/business/advertisement/ad';
import { environment } from '@env/environment';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AdvertisementService {
  private baseUrl: string = environment.baseApiUrl;
  private currentAd?: string;

  // Mock
  private ads: Ad[] = [
    {
      code: '1',
      url: 'http://www.google.com',
      picture: {
        alt: 'Pub',
        url: '/assets/images/pub_1.png',
      },
      origin: 'OA'
    },
    {
      code: '2',
      url: 'https://www.auchandrive.fr',
      picture: {
        alt: 'Pub',
        url: '/assets/images/pub_2.png',
      },
      origin: 'OA'
    },
  ];

  constructor(private http: HttpClient, private contextService: ContextService) {}

  /**
   * Obtenir une publicité national
   */
  getAdvertisement(): Observable<Ad> {
    // Bloc pour simuler des données
    if (environment.useMock) {
      const key: number = this.currentAd !== '1' ? 0 : 1;
      this.currentAd = this.ads[key].code;
      return of(this.ads[key]).pipe(delay(200));
    }

    return this.http.get<Ad>(`${this.baseUrl}/companies/${this.contextService.context.companyCode}/ad`);
  }

  /**
   * Obtenir plusieurs publicités
   */
  getAdvertisements(origin: string, nbAd: number): Observable<Ad[]> {
    const params = { nbAd: nbAd };
    return this.http.get<Ad[]>(`${this.baseUrl}/companies/${this.contextService.context.companyCode}/advertisements/${origin}`, { params:params });
  }

  /**
   * Obtenir une publicité suivant le magasin de départ du client
   */
  getAdvertisementByLocation(locationCode: string): Observable<Ad> {
    return this.http.get<Ad>(`${this.baseUrl}/companies/${this.contextService.context.companyCode}/ad/location/${locationCode}`);
  }

  /**
   * Mettre à jour le nombre de click sur une publicité
   */
  putAdvertisement(code: string): Observable<any> {
    return this.http.put(`${this.baseUrl}/companies/${this.contextService.context.companyCode}/ad/${code}`, null);
  }
}
